module.exports = __webpack_public_path__ + "assets/86bb277ae82c60d86ee240b07d95d8f5.mp4";